import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';

import {
  SELECT_DECLINABLE_ACTIVE,
  SELECT_DECLINABLE_ACTIVE_ID,
  SELECT_DECLINABLE_ALL,
  SELECT_DECLINABLE_ENTITY,
  SELECT_DECLINABLE_ERROR,
} from '@store/declinable';
import { DoodDeclinableModel } from '@core/models/product.model';

@Injectable({ providedIn: 'root' })
export class DeclinableStoreSelector {
  private readonly store = inject(Store);

  // Declinables
  readonly selectDeclinables$ = this.store.select(SELECT_DECLINABLE_ALL);
  readonly selectDeclinables = this.store.selectSignal(SELECT_DECLINABLE_ALL);
  selectDeclinable = (id: string): Observable<DoodDeclinableModel | undefined> =>
    this.store.select(SELECT_DECLINABLE_ENTITY(id));

  // Error
  selectError = this.store.select(SELECT_DECLINABLE_ERROR);

  // Active
  readonly selectActive$ = this.store.select(SELECT_DECLINABLE_ACTIVE);
  readonly selectActive = this.store.selectSignal(SELECT_DECLINABLE_ACTIVE);
  readonly selectActiveId$ = this.store.select(SELECT_DECLINABLE_ACTIVE_ID);
  readonly selectActiveId = this.store.selectSignal(SELECT_DECLINABLE_ACTIVE_ID);
}
